<script setup>
  import { computed } from 'vue'

  const props = defineProps({
    data: {
      type: Object,
      required: true
    }
  })

  const getHeadline = computed(() => {
    let text = 'Empty'
    props.data.elements.forEach((element) => {
      if (element.name === 'markup_final_page') {
        text = element.markup
      }
    })
    return text
  })

  const getBody = computed(() => {
    let text = 'Empty'
    props.data.elements.forEach((element) => {
      if (element.name === 'markup_final_page_message') {
        text = element.markup
      }
    })
    return text
  })
</script>

<template>
  <div
    class="confirmation-message"
  >
    <GridLayout
      hasGap
    >
      <LeftHeadline
        :text="getHeadline"
      />
      <div
        class="confirmation-message-inner lg:col-span-8"
        v-html="getBody"
      />
    </GridLayout>
  </div>
</template>

<style lang="scss" scoped>
  .confirmation-message-inner :deep(p) {
    @apply my-4 ~text-base/xl;
  }

</style>
